import {View} from 'backbone';
import template from 'dashboard/connections/details/autocomplete-webservices.ejs';
import constants from 'Constants';
import $ from 'jquery';
import xjService from 'xml/XJService';

class AutocompleteWebserviceModalView extends View {

    initialize(opts) {
        super.initialize(opts);

        this.model.set("title", opts.title, {silent:true});
        this.model.set("text", opts.text, {silent:true});
        this.isSend = opts.isSend;
        this.type = opts.type;
        
        $('body').append(this.$el);
        return this;
    }

    render(){
        const sessionVar = this.isSend ? constants.WS_ACTION_REQUEST_STORAGE_KEY_PREFIX : constants.WS_ACTION_RESPONSE_STORAGE_KEY_PREFIX;
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));

            $( constants.DIALOG_ID ).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 500,
                width: 700,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'Ok',
                        'class':'btn-select-item',
                        disabled: true,
                        click: () => {
                            let actionXML = this.model.get('ActionXML');
                            sessionStorage.setItem(sessionVar + actionXML.Action._id, $("#xmlResponse").val());

                            if(this.type === "xml"){
                                resolve(this.readXML());
                            }
                            else{
                                resolve(this.readJSON());
                            }
                            
                            this.closeModal();
                        }
                    },
                    {
                        'text': 'Cancel',
                        click: () => {
                            resolve();
                            this.closeModal();
                        }
                    }
                ],
                open: () => {
                    this.bindEvents();
                    //Load response XML (if any)
                    let actionXML = this.model.get('ActionXML');
                    let storedXMLResponse = sessionStorage.getItem(sessionVar + actionXML.Action._id);
                    if (storedXMLResponse) {                        
                        $("#xmlResponse").val(storedXMLResponse);
                        if (!this.validXML()){
                            $("#xmlResponse").val('');
                        }
                    }
                },
                close: () => {
                    this.unbindEvents();
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});


        });
    }

    _cleanResponseXML(xmlString){
        let _xmlString = xmlString.replace(/<[A-Za-z0-9]*:/g, '<')
        .replace(/<\/[A-Za-z0-9]*:/g, '</')
        .replace(/xmlns:[A-Za-z0-9]*=(["'])(\\?.)*?\1/g, '')
        .replace(/xmlns=(["'])(\\?.)*?\1/g, '')
        .replace(/\\/g, "");
        const actionXML = this.model.get('ActionXML');
        const xmlDoc = xjService.stringToXmlDoc(_xmlString);
        
        //If it is a SOAP action then we should get rid of <Envelope>, <Body> and <[Method name]Response> tags
        if (actionXML.Action._method && actionXML.Action._method.toLowerCase() === "soap" && xmlDoc && xmlDoc.firstElementChild && xmlDoc.firstElementChild.tagName 
            &&  xmlDoc.firstElementChild.tagName.toLowerCase() === "envelope" && xmlDoc.firstElementChild.firstElementChild 
            && xmlDoc.firstElementChild.firstElementChild.tagName && xmlDoc.firstElementChild.firstElementChild.tagName.toLowerCase() === "body" 
            && xmlDoc.firstElementChild.firstElementChild.firstElementChild){
                let _resultNode;
                if (xmlDoc.firstElementChild.firstElementChild.firstElementChild.tagName.toLowerCase().indexOf("response") > -1 
                    && xmlDoc.firstElementChild.firstElementChild.firstElementChild.firstElementChild){
                    _resultNode = xmlDoc.firstElementChild.firstElementChild.firstElementChild.children;
                }else{
                    _resultNode = xmlDoc.firstElementChild.firstElementChild.children;
                }

                let xmlElements = '';
                for (let i = 0; i < _resultNode.length; i++) {
                    xmlElements += xjService.xmlToString(_resultNode[i]);
                }

                _xmlString = `<___temporalPerfectAppsRoot___>${xmlElements}</___temporalPerfectAppsRoot___>`;
        }

        return _xmlString;
    }

    readXML() {
        let cleanedXML = $('#xmlResponse').val();
        if (cleanedXML) {
            cleanedXML = this._cleanResponseXML(cleanedXML);
        }

        const
            xmlDoc = xjService.stringToXmlDoc(cleanedXML),
            pathSet = new Set();

        this.pathXML(xmlDoc, xmlDoc.nodeName, pathSet);
        return [...pathSet];
    }

    pathXML(node, path, pathSet) {

        if (node.children && node.children.length > 0) {

            // List of elements:
            Array.from(node.children).forEach(child => {

                let nodeNameVerified = child.nodeName.replaceAll('.', constants.CONNECTION_DOT_PLACEHOLDER);

                // Element xPath
                this.pathXML(child, `${path}.${nodeNameVerified}`, pathSet);

                // Optional per-element attribute xPath list
                Array.from(child.attributes).forEach(attr => {
                    const
                        name = `${attr.ownerElement.nodeName} - ${attr.nodeName}`,
                        xPath = `${attr.ownerElement.nodeName}@${attr.nodeName}`;
                    this.pathXML(name, `${path}.${xPath}`, pathSet);
                });
            });
        } else {
            // Break our of recursion at the tail, here.
            pathSet.add(path.slice(path.indexOf('.') + 1).replace('___temporalPerfectAppsRoot___.', ''));
        }
    }

    validXML(e){
        let isValidXML = false;
        $('.btn-select-item').prop('disabled', true).addClass('ui-button-disabled').addClass('ui-state-disabled');
        const xmlResponse = $("#xmlResponse").val().replace(/\\/g, "");
        $("#xmlResponse").val(xmlResponse);

        const textAreaValue = this._cleanResponseXML(xmlResponse);
        if(textAreaValue && textAreaValue.length) {          
            try {
                if(this.type === "xml"){
                    $.parseXML(textAreaValue);
                } else{
                    JSON.parse(textAreaValue);
                }

                $('.btn-select-item').prop('disabled', false).removeClass('ui-button-disabled').removeClass('ui-state-disabled');
                isValidXML = true;
            } catch (e){
                console.log('AutocompleteWebserviceModalView: Input is not recognizable XML');
            }
        }

        return isValidXML;
    }

    readJSON(){
        let json = JSON.parse($('#xmlResponse').val());
        let dotNotation = this.convertJsonToDot(json);

        let params = Object.keys(dotNotation).map((key) => {
            return key;
        });

        return params;
    }

    convertJsonToDot(obj, parent = [], keyValue = {}) {

        const excludedProperties = ["_xmlns:json", "_json:Array", "$"];
        const createDotNotation = (key) => {

            let keyPath;

            if (Number.isInteger(key)) {
                parent[parent.length - 1] += "[]";
                keyPath = [...parent];
            }
            else {
                keyPath = [...parent, key.replaceAll('.', constants.CONNECTION_DOT_PLACEHOLDER)];
            }

            if (obj[key] !== null && typeof obj[key] === 'object') {
                Object.assign(keyValue, this.convertJsonToDot(obj[key], keyPath, keyValue));
            } else {
                keyValue[keyPath.join('.')] = obj[key];
            }

        }

        if (Array.isArray(obj)) {
            createDotNotation(0); //PF-9575 Create notation only for one object of the array
        }
        else {
            for (let key in obj) {
                if (!excludedProperties.includes(key)) {
                    createDotNotation(key);
                }
            }
        }        
        return keyValue;
    }

    bindEvents(){
        $(constants.DIALOG_ID).find('#xmlResponse').on('keyup change paste', e => setTimeout(this.validXML(e), 100) );
    }
    
    unbindEvents(){
        $(constants.DIALOG_ID).find('#xmlResponse').off('keyup change paste');
    }

    closeModal(){
        this.unbindEvents();
        $( constants.DIALOG_ID ).dialog("destroy").remove();
    }

}

export default AutocompleteWebserviceModalView;
